import { render, staticRenderFns } from "./ProofreadingConfirmationDialog.vue?vue&type=template&id=e9f63840&scoped=true"
import script from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingConfirmationDialog.vue?vue&type=style&index=0&id=e9f63840&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f63840",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f63840')) {
      api.createRecord('e9f63840', component.options)
    } else {
      api.reload('e9f63840', component.options)
    }
    module.hot.accept("./ProofreadingConfirmationDialog.vue?vue&type=template&id=e9f63840&scoped=true", function () {
      api.rerender('e9f63840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ProofreadingConfirmationDialog.vue"
export default component.exports